module.exports = __webpack_public_path__ + "img/pczk01.c6f0b63d.png";